module.exports = "../images/icons-race-details/Categoria.svg";